
import type { FC } from 'react';

import classNames from 'classnames';
import {useDrop} from 'react-dnd';
import { useDragAndDrop } from '@/utils/useDragAndDrop';
import { IDragQuestionProps } from '@/utils/ctype';
import GroupTitle from '../../../components/GroupTitle';
import KeyboardTip from '../../../components/KeyboardTip';
import Blocker from '../../../components/Blocker';
import Drag from '../../../components/Drag';
import Drop from '../../../components/Drop';
import HtmlParser from '../../../components/HtmlParser';
import style from './index.module.less';


const Container: FC<IDragQuestionProps> = function SummaryWithOptions(props) {
  
  const { data , saveAnswerHandle, pageData, loadAnswered, answerMap, keyIndex, setShowDragFieldHandle, setFocusIndexHandle} = props;
  const { collect = ''} = data || {};

  
  const {
    dustbins,
    boxes,
    recoverOption,
    recoverBlank,
    handleDrop,
    handleDropOptionList
  } = useDragAndDrop(data, {optionHidden: 'hidden', type: 'summaryOption', accepts: ['summaryOption', 'summaryBlank'], blankType: 'summaryBlank', saveAnswerHandle, pageData, loadAnswered, answerMap});
 
  const [{ isOver, canDrop }, drop] = useDrop({
    accept: ['summaryOption', 'summaryBlank'],
    drop: handleDropOptionList,
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  const TransportSurvey = (text: string ) => {
    const textArr = text.split('\n');
    return textArr.map((itemText, index) => {
      if (itemText) {
        return (
          <div className={style.completion} key={index}>
            {replacePlaceholder(itemText)}
          </div>
        );
      } else {
        return (
          <div key={index + '_br'}>
            <br />
          </div>
        );
      }
    });
  };
  const replacePlaceholder = (str: string) => {
    // 正则表达式匹配 $数字$
    const regex = /\$(\d+)\$/g;
    const parts = str.split(regex);
    
    const elements = parts.map((part, partIndex) => {
      // parts 中的奇数索引是数字，偶数索引是普通文本
      if (partIndex % 2 === 1) {
        const index = dustbins.findIndex((item) => {
          return item.data.id === Number(part);
        });
        if (index !== -1) {
          const item = dustbins[index];
          const {lastDroppedItem, accepts, type, uid, data} = item;
          // console.log('drop', item);
          
          return <Drop
            accept={accepts}
            lastDroppedItem={lastDroppedItem}
            onDrop={(item) => handleDrop(index, item)}
            index={index}
            data={item.data}
            recoverOption={recoverOption}
            recoverBlank={() => recoverBlank(index)}
            type={type}
            key={index}
            blankBoxClass={style.blankBox}
            // blankClass={style.blank}
            // optionClass={style.option}
            id={`question${data.number}`}
            uid={uid}
            onFocus={() => {setFocusIndexHandle&&setFocusIndexHandle(data.number);}}
          />;
        } else {
          return null;
        }
        
      } else {
        return <HtmlParser htmlString={part} key={`p_${partIndex}`}></HtmlParser>;
      }
    });
    return elements;
  };

  return (
    <div className={style.box}>
      <KeyboardTip></KeyboardTip>
      <Blocker>
        <GroupTitle title={data.title}/>
        {
          TransportSurvey(collect)
        }
      </Blocker>
      <div data-exam-drop-hover={isOver} className={classNames(style.answer, isOver ? style.isOver : '')} ref={drop}>
        {
          boxes.map(({ data, type, display, optionHidden, uid}, index) => {
            return (
              <Drag data={data} type={type} key={index} index={index} optionClass={style.m3}
                display={display} optionHidden={optionHidden} uid={uid} setShowDragFieldHandle={setShowDragFieldHandle}/>
            );
          })
        }
      </div>
    </div>
  );
};

export default Container;
